import React, { ReactNode } from 'react';
import DialogDetalheProduto from './DialogDetalheProduto';
import { createGenericModalContext } from '../../../../../components/BasicComponents/GenericModalContext';

const { GenericModalProvider, useGenericModal } = createGenericModalContext<string>();

export const ModalDetalheProdutoProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    return (
        <GenericModalProvider
            ModalComponent={DialogDetalheProduto}
            urlParam="detalhe-produto"
        >
            {children}
        </GenericModalProvider>
    );
};

export const useModalDetalheProduto = useGenericModal;